import React, { useState, useEffect } from 'react';
import styles from './SlidingDrawer.module.css';
import { SlidingDrawerProps } from './types';
import { createPortal } from 'react-dom';

const SlidingDrawer: React.FC<SlidingDrawerProps> = ({
  isOpen,
  onClose,
  children,
}) => {
  const [shouldRender, setShouldRender] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      // Prevent scrolling on body when drawer is open
      document.body.style.overflow = 'hidden';
    } else {
      // wait for the animation to finish before unmounting.
      const timer = setTimeout(() => {
        setShouldRender(false);
        document.body.style.overflow = '';
      }, 300); // must match the animation duration

      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  if (!shouldRender) {
    return null;
  }

  return createPortal(
    <div
      className={styles.drawerOverlay}
      data-closing={!isOpen}
      onClick={onClose}
    >
      <div
        className={styles.drawerContent}
        data-closing={!isOpen}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
};

export default SlidingDrawer;
